import { render } from "./areYouSureModal.vue?vue&type=template&id=1acfa478&scoped=true&ts=true"
import script from "./areYouSureModal.vue?vue&type=script&lang=ts"
export * from "./areYouSureModal.vue?vue&type=script&lang=ts"

import "./areYouSureModal.vue?vue&type=style&index=0&id=1acfa478&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acfa478"]])

export default __exports__